import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { CommentVote } from './index'
import { Query } from "react-apollo";
import { clientCredentials } from '../../graphql/queries';

class CommentActions extends React.Component {

	render() {
        return (
            <Query query={clientCredentials}>
                {({ data }) => {

                    return (
                        <React.Fragment>
                            {(this.props.user.id === data.clientCredentials.id) && 
                                <button className="button button--icon comment-subicon" onClick={this.props.handleEdit}>
                                        <FontAwesomeIcon icon="pen" />
                                </button>}
                            <CommentVote commentId={this.props.id} votes={this.props.votes} />
                        </React.Fragment>
                    )
                }}
            </Query>
        )
	}
}

export default CommentActions


// WEBPACK FOOTER //
// ./src/components/comment/CommentActions.js